<script>
import HelpPrimaryGroupPanel from '@/components/help/help-primary-group-panel.vue'
import baseMixin from '@/mixins/baseMixin'
import GeneralFileList from '@components/general/general-file-list.vue'
import GeneralFilePreview from '@components/general/general-file-preview.vue'
import Layout from '@layouts/main.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'HelpView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Help page.' }],
    }
  },

  components: {
    Layout,
    GeneralFileList,
    GeneralFilePreview,
    HelpPrimaryGroupPanel,
  },

  mixins: [baseMixin],

  data() {
    return {
      showDownloadDialog: false,
      filePath: '',
    }
  },

  computed: {
    ...mapGetters({
      getSelectedClientIds: 'client/getSelectedClients',
      clientList: 'auth/getAllClients',
    }),

    selectedClientsList() {
      return this.clientList.filter(({ clientId }) =>
        this.getSelectedClientIds.includes(clientId)
      )
    },
  },

  methods: {
    downloadFile(file) {
      this.showDownloadDialog = true
      this.filePath = file.filePath
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageHeader :title="$t('help.pageTitle')" />

    <section>
      <header>
        <h6 class="text-h6">{{ $t('help.clientContactsTitle') }}</h6>
      </header>

      <HelpPrimaryGroupPanel :client-list="selectedClientsList" />
    </section>

    <section>
      <header class="mt-8">
        <h6 class="text-h6">{{ $t('layout.generalFilesListTitle') }}</h6>
      </header>
      <GeneralFileList class="mt-4" @downloadGeneralFile="downloadFile" />
    </section>

    <GeneralFilePreview :show.sync="showDownloadDialog" :file-path="filePath" />
  </Layout>
</template>
